/**
 * Module Hierarchy Map Controller — OL VectorSource 동기화용 상태ful 어댑터
 *
 * 사용 예 (다른 지도):
 *   const controller = createModuleHierarchyMapController();
 *   controller.setFeatureCache(allOlFeatures);
 *   const plan = controller.syncSource(vectorSource, treeRowPayload);
 *   applyModuleHierarchyHighlightStyles(plan.highlight, { Style: olStyle, ... });
 */
import { planModuleHierarchyMapSelection } from './moduleHierarchySelection';

/**
 * @param {object} [options]
 * @param {import('ol/Feature').default[]} [options.initialCache]
 */
export function createModuleHierarchyMapController({ initialCache = [] } = {}) {
  let featureCache = [...initialCache];
  let lastScopeKey = null;

  return {
    setFeatureCache(features) {
      featureCache = features ? [...features] : [];
      lastScopeKey = null;
    },

    getFeatureCache() {
      return featureCache;
    },

    clear() {
      featureCache = [];
      lastScopeKey = null;
    },

    resetScopeKey() {
      lastScopeKey = null;
    },

    /** 순수 계획만 (source 미변경) */
    planSelection(target) {
      return planModuleHierarchyMapSelection(featureCache, target);
    },

    /**
     * 캐시 → source 가시 피처 동기화
     * @param {import('ol/source/Vector').default} source
     * @param {object} target
     * @param {{ skipIfSameScope?: boolean }} [options]
     * @returns {ReturnType<planModuleHierarchyMapSelection> & { skipped: boolean }}
     */
    syncSource(source, target, { skipIfSameScope = true } = {}) {
      const plan = planModuleHierarchyMapSelection(featureCache, target);

      if (
        skipIfSameScope &&
        plan.scopeKey != null &&
        plan.scopeKey === lastScopeKey &&
        source?.getFeatures?.()?.length
      ) {
        return { ...plan, skipped: true };
      }

      lastScopeKey = plan.scopeKey;
      source?.clear?.();
      if (plan.visible.length) {
        source.addFeatures(plan.visible);
      }

      return { ...plan, skipped: false };
    }
  };
}
